import { graphql } from "gatsby";
import React from "react";
import Video from "../../components/Video";
import { HomeVideoDataFragment } from "../../../graphql-types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const togglePlay = /* istanbul ignore next */ (e: any) =>
  e.target.paused ? e.target.play() : e.target.pause();

type Props = {
  homeVideo: HomeVideoDataFragment;
};

const HomeVideo = ({
  homeVideo: {
    description,
    title,
    video: { videoH264 },
    videoPoster: { publicURL },
  },
}: Props) => {
  if (!videoH264?.path) {
    throw new Error("Could not find home video");
  }

  return (
    <div className="home-video">
      <h2 className="text-center uppercase title">{title}</h2>
      <Video
        path={videoH264?.path}
        description={description}
        screenshots={publicURL ? [{ path: publicURL }] : []}
        controls={false}
        onClick={togglePlay}
      />
    </div>
  );
};

export const fragments = {
  homeVideo: graphql`
    fragment HomeVideoData on HomeVideo {
      description
      title
      video {
        videoH264 {
          path
        }
      }
      videoPoster {
        publicURL
      }
    }
  `,
};

export default HomeVideo;
